import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info" }

import { Viewer } from "@bytemd/vue-next";

import { WriteUpVO } from "../generated";
import gfm from "@bytemd/plugin-gfm";
import highlight from "@bytemd/plugin-highlight-ssr";
import math from "@bytemd/plugin-math-ssr";

/**
 定义组件属性类型
 */
interface Props {
  post: WriteUpVO;
}

/**
 给组件指定初始值
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'WriteUpCard',
  props: {
    post: { default: () => ({} as WriteUpVO) }
  },
  setup(__props: any) {

const props = __props;
const plugins = [
  gfm(),
  highlight(),
  math(),
  // Add more plugins here
];

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "card" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { style: {"align-items":"center"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_avatar, { size: 100 }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: props.post.user?.userAvatar,
                    alt: "头像"
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 16 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, "题解作者：" + _toDisplayString(props.post.user?.userName), 1),
              _createElementVNode("div", _hoisted_3, "编写时间：" + _toDisplayString(props.post?.createTime), 1),
              _createElementVNode("div", _hoisted_4, "发布时间：" + _toDisplayString(props.post?.updateTime), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Viewer), {
        plugins: plugins,
        value: props.post?.content
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})